import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as globalActions from '../redux/actions/globalActions'
import localeConfig from '../config/locale'

class LocaleSwitch extends Component {
  constructor(props) {
    super(props)

    this.setLang1 = this.setLang1.bind(this)
    this.setLang2 = this.setLang2.bind(this)
  }

  setLang1(e) {
    localStorage.setItem(localeConfig.name, localeConfig.lang1)
    this.props.toggleLocale(localStorage.getItem(localeConfig.name))
    
    this.props.locale === localeConfig.lang1 ? e.preventDefault() : null
    window.location.reload();
  }
  setLang2(e) {
    localStorage.setItem(localeConfig.name, localeConfig.lang2)
    this.props.toggleLocale(localStorage.getItem(localeConfig.name))
    
    this.props.locale === localeConfig.lang2 ? e.preventDefault() : null
    window.location.reload();
  }

  render() {
    // let currentPath = window.location.hash.replace('/','');
    // const frenchPaths = ['nos-souches','questions-frequemment-posees','medias','infos-et-evenements','declaration-de-confidentialite','ou-acheter', 'contactez-nous'];
    // const engPaths = ['our-strains','frequently-asked-questions','news-and-events', 'contact','where-to-buy','privacy-policy','media'];
    // const _this = this;
    
    // frenchPaths.forEach((item) => {
    //   if (currentPath.includes(item)) {
    //     if (_this.props.locale === localeConfig.lang1) {
    //       localStorage.setItem(localeConfig.name, localeConfig.lang2)
    //       _this.props.toggleLocale(localStorage.getItem(localeConfig.name))
    //       _this.props.locale === localeConfig.lang2
    //       return false;
    //     }
    //   }
    // });

    // engPaths.forEach((item) => {
    //   if (currentPath.includes(item)) {
    //     if (_this.props.locale === localeConfig.lang2) {
    //       localStorage.setItem(localeConfig.name, localeConfig.lang1)
    //       _this.props.toggleLocale(localStorage.getItem(localeConfig.name))
    //       _this.props.locale === localeConfig.lang1
    //       return false;
    //     } else {
    //       localStorage.setItem(localeConfig.name, localeConfig.lang2)
    //     }
    //   }
    // });

    if(this.props.activeDoc) {
      let { 
        activeDoc, 
        locale 
      } = this.props
      let linkTo

      // console.log(activeDoc)

      if (activeDoc.type === 'home_page') {
        linkTo = `/`;
      } else if(activeDoc.type === 'product_page') { 
        linkTo = `/${locale !== localeConfig.lang1 ? 'our-strains' : 'nos-souches'}/${activeDoc.alternate_languages[0].uid}`
      } else {
        linkTo = `/${activeDoc.alternate_languages[0].uid}`
      }

      return (
        <div className="locale-switch-wrapper">
          <Link 
            to={linkTo}
            className={`locale-switch ${locale === localeConfig.lang1 ? 'active' : ''}`}
            onClick={this.setLang1}
          >
            { localeConfig.lang1.split('-')[0] }
          </Link>
          <Link 
            to={linkTo}
            className={`locale-switch ${locale === localeConfig.lang2 ? 'active' : ''}`}
            onClick={this.setLang2}
          >
            { localeConfig.lang2.split('-')[0] }
          </Link>
        </div>
      )
    } 
    return (
      <div className="locale-switch-wrapper">
        <Link to="/" className={`locale-switch ${this.props.locale === localeConfig.lang1 ? 'active' : ''}`} onClick={this.setLang1}> { localeConfig.lang1.split('-')[0] }</Link>
        <Link to="/" className={`locale-switch ${this.props.locale === localeConfig.lang2 ? 'active' : ''}`} onClick={this.setLang2}> { localeConfig.lang2.split('-')[0] }</Link>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  activeDoc: state.prismic.activeDoc,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { toggleLocale: globalActions.toggleLocale, },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(LocaleSwitch)


// WEBPACK FOOTER //
// ./src/components/LocaleSwitch.js